import React, { Component } from 'react'
class AdMPU extends Component {
  componentDidMount(){
    const script=document.createElement('script')
    script.src="https://ads.counciladvertising.net/code/southglos/doublempu/public"
    script.defer=true;
    script.setAttribute("data-can-ad","true")
    this.instance.appendChild(script)
    
  }
  render() {
    return (
    <div className="ads__mpu dont-print" ref={el => (this.instance = el)} >
        <p>Advertisement</p>
    </div>
    )
  }
}
export default AdMPU